import { useEffect, useState } from "react";
import { Type } from "lucide-react";

const STORAGE_KEY = "typoMode";

export default function TypographyToggle() {
  const [legacy, setLegacy] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY) === "legacy";
    if (saved) {
      document.documentElement.classList.add("typo-legacy");
      setLegacy(true);
    }
    const onKey = (e: KeyboardEvent) => {
      if (e.shiftKey && (e.key === "T" || e.key === "t") && !e.metaKey && !e.ctrlKey && !e.altKey) {
        const target = e.target as HTMLElement | null;
        if (target && (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable)) return;
        toggle();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggle = () => {
    const next = !document.documentElement.classList.contains("typo-legacy");
    document.documentElement.classList.toggle("typo-legacy", next);
    localStorage.setItem(STORAGE_KEY, next ? "legacy" : "current");
    setLegacy(next);
  };

  return (
    <button
      onClick={toggle}
      title="Toggle typography (Shift+T)"
      className="flex items-center gap-2 rounded-full bg-foreground text-background px-4 py-2 text-sm font-semibold shadow-lg hover:opacity-90 transition"
    >
      <Type className="h-4 w-4" />
      {legacy ? "Before" : "After"}
    </button>
  );
}
